// bg image import
import two from './media/bg/2.0.png';
import four from './media/bg/4.0.png';
import av from './media/bg/av.png';
import bb from './media/bg/bb.png';
import board from './media/bg/board.png';
import disk from './media/bg/disk.png';
import ha from './media/bg/ha.png';
import iot from './media/bg/iot.png';
import iran from './media/bg/iran.png';
import mc from './media/bg/mc.png';
import os from './media/bg/os.png';
import qr from './media/bg/qr.png';
import robot from './media/bg/robot.png';
import siemens from './media/bg/siemens.png';
import task from './media/bg/task.png';
import vision from './media/bg/vision.png';
import c2 from './media/logos/c#.png';
import c from './media/logos/c.png';
import css from './media/logos/css.png';
import html from './media/logos/html.png';
import java from './media/logos/java.png';
import js from './media/logos/js.png';
import kul from './media/logos/kuleuven.png';
import php from './media/logos/php.png';
import python from './media/logos/python.png';
import react from './media/logos/react.png';
import sharif from './media/logos/sharif.png';
import unity from './media/logos/unity.png';
import vba from './media/logos/vba.png';

// project data
export const projectData = [
  {
    id: 'Siemens',
    color: '#FF5420',
    title: 'Siemens Healthineers',
    bg: siemens,
    desc: 'One year of full-time job at Siemens Healthineers as an ultrasound engineer'
  },
  {
    id: 'OS',
    color: '#F48636',
    title: 'Omran Soule Co.',
    bg: os,
    desc: 'Part-time job at Omran Soule Co. as a python developer and full stack engineer'
  },
  {
    id: 'Robot',
    color: '#F7EBE1',
    title: 'Robot Path Simulator',
    bg: robot,
    desc: 'A small script in Python that turns strings into movement commands for a robot'
  },

  {
    id: 'Iran',
    color: '#F7C69E',
    title: 'Iran Population Map',
    bg: iran,
    desc: 'An interactive population map of Iran using React, Python, Deck.gl and Mapbox'
  },

  {
    id: 'IoT',
    color: '#FECB4B',
    title: 'IoT Boards',
    bg: iot,
    desc: 'A study on the possibility of imlplementing SBCs into home appliences'
  },

  {
    id: 'BB',
    color: '#3D6033',
    title: 'Breaking Bad Characters',
    bg: bb,
    desc: 'Another small script in Python that outputs episode numbers of Breaking Bad series based on provided charachter input'
  },

  {
    id: 'MC',
    color: '#7CBD6B',
    title: 'Minecraft Farm Wiki',
    bg: mc,
    desc: 'A hobby website that deals with technical aspect of Minecraft'
  },

  {
    id: 'Vision',
    color: '#2F9A80',
    title: 'Computer Vision and Smart Assistant',
    bg: vision,
    desc: 'A system that gets inputs from the camera and adapts the assistant based on the situation'
  },

  {
    id: 'Four',
    color: '#00FFCC',
    title: 'Personal Website v4.0',
    bg: four,
    desc: 'This website! Created with React'
  },

  {
    id: 'QR',
    color: '#30D9D9',
    title: 'Object and QR code Detection',
    bg: qr,
    desc: 'A Python project to navigate a drone based on the camera input and scan QR codes to gather points'
  },

  {
    id: 'Task',
    color: '#011936',
    title: 'Task Tracker',
    bg: task,
    desc: 'A simple task tracker in React'
  },

  {
    id: 'Two',
    color: '#323840',
    title: 'Personal Website v2.0',
    bg: two,
    desc: "Previous version of my personal website. It's in Vanilla JS"
  },

  {
    id: 'Disk',
    color: '#A3ACBF',
    title: 'Disk Sorter',
    bg: disk,
    desc: 'A disk sorter based on varying thicknesses of disks.'
  },

  {
    id: 'AV',
    color: '#252140',
    title: 'Autonomous Vehicle Components',
    bg: av,
    desc: "My bachelor's thesis. A study on different methods and components of autopilot systems with the goal of implementing said systems into ordinary vehicles"
  },

  {
    id: 'HA',
    color: '#F7C8D6',
    title: 'Hamrahan Atebba Co.',
    bg: ha,
    desc: 'Part-time job at Hamrahan Atebba Co. as an IT manager and full stack engineer'
  },

  {
    id: 'Board',
    color: '#B3444F',
    title: 'Self-balancing Robot',
    bg: board,
    desc: 'A self-balancing transportation robot'
  }
];

export const eduData = [
  {
    text: 'M.Sc. in Electromechanical Engineering from KU Leuven',
    logoSrc: kul,
    link: 'https://onderwijsaanbod.kuleuven.be/opleidingen/e/CQ_52921897.htm#activetab=diploma_omschrijving'
  },
  {
    text: 'B.Sc. in Mechatronics Engineering from Sharif University of Technology',
    logoSrc: sharif,
    link: 'http://www.en.sharif.edu/'
  }
];

export const skillData = [
  {
    text: 'Python',
    logoSrc: python
  },
  {
    text: 'React',
    logoSrc: react
  },
  {
    text: 'JavaScript',
    logoSrc: js
  },
  {
    text: 'CSS',
    logoSrc: css
  },
  {
    text: 'HTML',
    logoSrc: html
  },
  {
    text: 'PHP',
    logoSrc: php
  },
  {
    text: 'Java',
    logoSrc: java
  },
  {
    text: 'C/C++',
    logoSrc: c
  },
  {
    text: 'VBA',
    logoSrc: vba
  },
  {
    text: 'C#',
    logoSrc: c2
  },
  {
    text: 'Unity',
    logoSrc: unity
  }
];
